module.exports = __webpack_public_path__ + "img/g0129.1e4a8f58.png";